import { Tooltip, Typography } from '@cobliteam/ui/components';

const ProductivityPhaseOutTooltip = ({ children }: { children: JSX.Element }) => (
  <Tooltip
    content={
      <Typography variant='caption-medium' color='white'>
        Exporte dados de produtividade através do relatório de Trajetos e paradas.
        <a className='ml-1 font-medium text-link text-xs underline' href='https://suporte.cobli.co/resumo-de-trajetos-e-paradas' target='_blank' rel='noopener noreferrer'>
          Saiba mais
        </a>
      </Typography>
    }
  >
    {children}
  </Tooltip>
);

export default ProductivityPhaseOutTooltip;
